export const ISO_CODES = {
  en: 'EN',
  pt: 'PT',
};
